export default __webpack_public_path__ + "static/media/TX_Arbal_1.5b95d91d.png";